import React, { useState } from "react";
import Navbars from "../components/Navbar/Navbars";
import Footer from "../components/Footer/Footer";

import About from "../components/About/About";
// Adjust import path if necessary

// Each service component’s content (details and image)

const AboutPage = () => {
  return (
    <div className="services-page">
      <Navbars />
    <About/>

      <Footer />
    </div>
  );
};

export default AboutPage;
